export enum ProductApiType {
  CONTENT_API = 'content_api',
  MERCHANT_API = 'merchant_api',
}

export interface Merchant {
  id: string;
  name: string;
  handle: string;
  brandHomeUrl: string;

  enabled: boolean;
  verified: boolean;
  googleMerchantId: string;
  contentApiIntegrated: boolean;
  preorderPeriod: number;
  productApiType: ProductApiType;
  productApiEnabled: boolean;
}
